<template>
  <div class="bg-light-gray mb-2">
    <validation-observer ref="formModalObserver" novalidate tag="form">
      <div class="row">
        <div class="col-12 mb-3">
          <icon-view
            :has-border="false"
            icon="fas fa-arrow-to-left text-orange"
            icon-size="17px"
            title="Notificar Devolución"
            variant="custom-icon-view"
            icon-background="white"
          />
        </div>
        <div class="col-12 mb-4">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-date-picker
              required
              v-model="model.returnDate"
              :max-date="new Date()"
              :min-date="initialDate"
              placeholder="DD/MM/YYYY"
              class="custom-datetime-picker-container"
              container-class="w-100"
              :error="errors[0]"
              :custom-error-msg="'La fecha es requerida'"
              label="Fecha de Devolución de Equipo:"
            />
          </validation-provider>
        </div>
        <div class="col-12 mb-4">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-text-area
              id="txtComment"
              :maxlength="3000"
              placeholder="Escribe un comentario"
              label="Comentario:"
              v-model="model.comment"
              :error="errors[0]"
              :custom-error-msg="'Este campo es requerido'"
              :show-char-count="true"
              :count-classes="['d-block text-right']"
            />
          </validation-provider>
        </div>
        <div class="col-12">
          <div class="bg-white px-4 py-4 mt-3 rounded">
            <div class="mb-3 font-weight-bold">
              <i class="fas fa-plus-circle text-orange mr-2"></i>
              Seleccione Accesorios a Devolver con el Equipo
            </div>
            <div v-for="(accessory, index) in accessories" :key="index">
              <custom-callout class="mb-3 custom-callout" :has-toggle="false">
                <div class="row p-3">
                  <div class="col-12 col-lg-3 border-r">
                    <div class="bold font-16">{{ accessory.name }}</div>
                    <div class="color-secondary-6 font-14">
                      {{ accessory.model }}
                    </div>
                  </div>
                  <div class="col-12 col-lg-7">
                    <div class="color-secondary-6 font-14">
                      Estatus:
                    </div>
                    <div class="bold">
                      <span class="d-flex align-items-center">
                        <div
                          class="status-indicator"
                          :style="{
                            backgroundColor: '#DDB3D7',
                          }"
                        >
                          &nbsp;
                        </div>
                        <span class="text font-weight-bold">
                          Asignado
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="col-sm text-right">
                    <action-button
                      id="modal-btn-anadir"
                      :variant="
                        !accessory.isSelected
                          ? 'outline-success ' + (isMobile ? 'w-100 mt-4' : '')
                          : 'success ' + (isMobile ? 'w-100  mt-4' : '')
                      "
                      type="button"
                      i="fas fa-check"
                      data-target="#modal-cambiar"
                      @click="onSelectAccessory(index)"
                    >
                      {{
                        accessory.isSelected ? 'Seleccionado' : 'Seleccionar'
                      }}
                    </action-button>
                  </div>
                </div>
              </custom-callout>
            </div>
            <custom-result-not-found
              v-if="accessories.length == 0"
              text="No hay Información Disponible."
            />
          </div>
        </div>
      </div>
    </validation-observer>
    <div class="d-flex justify-content-end align-items-center mt-4">
      <action-button
        id="btnCancel"
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 px-3"
        @click="$emit('close')"
      />
      <action-button
        id="btnSave"
        i="fas fa-save"
        text="Guardar"
        variant="success px-3"
        @click="handlerSave"
      />
    </div>
  </div>
</template>
<script>
import ActionButton from 'ActionButton';
import IconView from 'icon-view';
import CustomTextArea from '@quisit/custom-text-area';
import CustomCallout from 'custom-callout';
import CustomResultNotFound from 'custom-result-not-found';
import CustomDatePicker from 'custom-date-picker';

import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import inventoryCatalogService from '@/services/api/inventorycatalog.api';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'NotifyReturn',
  components: {
    ActionButton,
    IconView,
    CustomTextArea,
    CustomCallout,
    CustomResultNotFound,
    CustomDatePicker,
  },
  mixins: [alertMixin],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      initialDate: null,
      accessories: [],
      unselectedAccessories: [],
      model: {
        comment: '',
        returnDate: null,
      },
    };
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
  },
  async mounted() {
    Promise.all([this.getMinDate(), this.getAccessories()]);
  },
  methods: {
    async handlerSave() {
      const isvalid = await this.$refs.formModalObserver.validate();
      if (!isvalid) {
        this.ShowToast(
          'Alerta',
          'Por favor completa los campos requeridos.',
          'error'
        );
        return;
      }

      const isConfirmed = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea guardar la información documentada?`,
        'Sí',
        'No'
      );

      if (!isConfirmed) {
        return;
      }

      const payload = {
        ...this.model,
        equipmentId: this.item.id,
        unselectedAccessories: this.unselectedAccessories,
      };

      this.$emit('save', payload);
    },
    async getAccessories() {
      const {
        data,
      } = await inventoryCatalogService.getAssignedAccessoriesByEquipment(
        this.item.id
      );
      this.accessories = data.map((x) => ({
        ...x,
        accepted: true,
        isSelected: true,
      }));
    },
    async getMinDate() {
      const { data } = await inventoryCatalogService.getInititalReturnDate(
        this.item.id
      );

      this.initialDate = moment(data)
        .add(-1, 'days')
        .toDate();
    },
    onSelectAccessory(index) {
      const item = this.accessories[index];
      item.isSelected = !item.isSelected;
      if (!item.isSelected) {
        this.unselectedAccessories.push(item.id);
      } else {
        const i = this.unselectedAccessories.findIndex((x) => x === item.id);
        if (i >= 0) this.unselectedAccessories.splice(i, 1);
      }
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss"></style>
